export const getGeodata = (recObject) => (recObject.addresses[0] && recObject.addresses[0].geodata) || {};

export const defaultCenter = { lng: -96, lat: 40 };
export const defaultZoom = 3;

export const getMapViewport = (recObjectsWithLocation) => {
  let westernmost = 180; // max longitude (so everything will be west of this)
  let easternmost = -180; // min longitude (so everything will be east of this)
  let northernmost = -90; // max latitude
  let southernmost = 90; // min latitude
  let anyLocationData = false;

  let viewport = {};

  recObjectsWithLocation.forEach((recObject) => {
    let address = recObject.addresses[0];

    if (
      !address ||
      (address.city == null && address.state == null && address.zip == null && address.neighborhood == null)
    ) {
      return;
    }

    anyLocationData = true;

    const { southwest, northeast } = getGeodata(recObject).viewport;
    const western = southwest.lng;
    const southern = southwest.lat;
    const northern = northeast.lat;
    const eastern = northeast.lng;

    if (western < westernmost) {
      westernmost = western;
    }
    if (southern < southernmost) {
      southernmost = southern;
    }
    if (northern > northernmost) {
      northernmost = northern;
    }
    if (eastern > easternmost) {
      easternmost = eastern;
    }
  });

  if (anyLocationData) {
    const latDiff = northernmost - southernmost;
    const lngDiff = easternmost - westernmost;
    const buffer = 0.25;

    westernmost -= lngDiff * buffer;
    easternmost += lngDiff * buffer;
    southernmost -= latDiff * buffer;
    northernmost += latDiff * buffer;

    viewport = {
      southwest: [westernmost, southernmost],
      northeast: [easternmost, northernmost],
    };
  }

  return viewport;
};
